// Revealing animation Js Function
document.addEventListener("DOMContentLoaded", function () {
  AOS.init();
});

// Custom Accordions Js
document.addEventListener("DOMContentLoaded", function () {
  let acc = document.querySelectorAll(
    ".custom-collapsible-accordions-container .accordion"
  );

  acc.forEach(function (accordion) {
    accordion.addEventListener("click", function () {
      this.classList.toggle("active");
      let panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
});


const megaMenu = document.getElementById('Details-HeaderMenu-2');
const megaMenuContent = document.getElementById('MegaMenu-Content-2');
let closeTimeout;

megaMenu.addEventListener('mouseenter', function () {
  clearTimeout(closeTimeout);
  this.setAttribute('open', 'open');
});

megaMenu.addEventListener('mouseleave', function () {
  closeTimeout = setTimeout(() => {
    this.removeAttribute('open');
  }, 200);
});

megaMenuContent.addEventListener('mouseenter', function () {
  clearTimeout(closeTimeout);
  megaMenu.setAttribute('open', 'open');
});

megaMenuContent.addEventListener('mouseleave', function () {
  closeTimeout = setTimeout(() => {
    megaMenu.removeAttribute('open');
  }, 200);
});
